<template>
  <main-layout>
    <template slot="title">
      空中英語教室 教學資源
    </template>

    <template slot="main">
      <div class="download">
        <el-row :gutter="10" class="upload-functional">
          <el-col :span="5">
            <div class="download-date__wrapper">
              <DateSelect :level="level" />
            </div>
          </el-col>

          <el-col :span="10">
            <div class="download-item__wrapper">
              <ItemSelect :level="level" />
            </div>
          </el-col>
        </el-row>

        <div class="download-table__wrapper">
          <Table/>
        </div>
      </div>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout'
import DateSelect from '@/components/download/DateSelect'
import ItemSelect from '@/components/download/ItemSelect'
import Table from '@/components/download/Table'

export default {
  name: 'home-download',
  components: {
    MainLayout,
    DateSelect,
    ItemSelect,
    Table
  },
  data () {
    return {
      level: 'sc'
    }
  }
}
</script>
